import { AnyAction, ThunkDispatch } from "@reduxjs/toolkit"
import { useDispatch } from "react-redux"
import { RootState } from "appRedux/store"

export const useThunkDispatch = () =>
    useDispatch<ThunkDispatch<RootState, void, AnyAction>>()
